import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  codeSearchPortalLink: {
    id: 'bitkit.navigation.searchResults.codeSearchPortalLink',
    description:
      'Link text for the generic Code Search Portal link in the horizontal platform search',
    defaultMessage: 'Search for code in Code Search Portal',
  },
  codeSearchPortalRepositoryLink: {
    id: 'bitkit.navigation.searchResults.codeSearchPortalRepositoryLink',
    description:
      'Link text for the repository-scoped Code Search Portal link in the horizontal platform search',
    defaultMessage: 'Search for code in {repoName} in Code Search Portal',
  },
  repositoriesHeading: {
    id: 'bitkit.navigation.searchResults.repositoriesHeading',
    description: 'Heading for repository search results',
    defaultMessage: 'Repositories',
  },
  compassRequestAccess: {
    id: 'bitkit.navigation.compassTab.compassRequestAccess',
    description: 'Button text for non-admins to request access to Compass',
    defaultMessage: 'Request access to Compass',
  },
  accessRequestSentHeading: {
    id: 'bitkit.navigation.compassTab.accessRequestSentHeading',
    description: 'Header for the request access flag',
    defaultMessage: 'Access request sent',
  },
  accessRequestSentDescription: {
    id: 'bitkit.navigation.compassTab.accessRequestSentDescription',
    description: 'Description for the request access flag',
    defaultMessage: 'We’ve let your Bitbucket admin know.',
  },
  accessRequestSentHeadingError: {
    id: 'bitkit.navigation.compassTab.accessRequestSentHeadingError',
    description: 'Header for the request access flag when there is an error',
    defaultMessage: 'Error sending access request',
  },
  accessRequestSentDescriptionError: {
    id: 'bitkit.navigation.compassTab.accessRequestSentDescriptionError',
    description:
      'Description for the request access flag when there is an error',
    defaultMessage: 'Please reload the page and try again.',
  },
  rovoSpotlightHeading: {
    id: 'bitkit.navigation.rovoSpotlightHeading',
    description: 'Heading for the Rovo spotlight tab',
    defaultMessage: 'Harness the power of your team',
  },
  rovoSpotlightDescription: {
    id: 'bitkit.navigation.rovoSpotlightDescription',
    description: 'Description for the Rovo spotlight tab',
    defaultMessage:
      'Rovo Chat is here to help streamline your workflow and get clarity on code. Find code reviewers, summarize code changes, or find pull requests.',
  },
  rovoSpotlightTryChatButton: {
    id: 'bitkit.navigation.rovoSpotlightTryChatButton',
    description: 'Button text for the Rovo spotlight tab',
    defaultMessage: 'Try Chat',
  },
  rovoSpotlightDismissButton: {
    id: 'bitkit.navigation.rovoSpotlightDismissButton',
    description: 'Button text for the Rovo spotlight tab',
    defaultMessage: 'Dismiss',
  },
});
